import React, { useState, useEffect } from "react";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import UploadMultiFile from "../../../components/GenericComponent/UploadMultiFile";
import ChiTietCuaHangApi from "../../../service/chiTietCuaHangApi";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { formatNumber } from "utils/currencyFormat";
import NumberInput from "components/GenericComponent/NumberInput";

export const ThuocTinhTaiSan2 = ({
  currentForm,
  datanew,
  update,
  AnhTaiSan,
  updateAnhTaiSan,
}) => {
  const { errors, register, control } = currentForm;
  const [imageTaiSans, setImageTaiSans] = useState([]);
  const [listKhauHao, setListKhauHao] = useState([]);

  const [nameCode, setNameCode] = React.useState("");
  useEffect(() => {
    ChiTietCuaHangApi.chiTietCuaHangHienTai().then((response) => {
      setNameCode(response.data.Code);
    });
  }, []);

  useEffect(() => {
    generateKhauHao();
  }, [
    datanew?.KhauHao?.TienKhauHao,
    datanew?.KhauHao?.ThoiGianKhauHao,
    datanew?.KhauHao?.ThoiGianBatDauKhauHao,
  ]);

  useEffect(() => {
    update({
      ...datanew,
      KhauHao: {
        ...datanew.KhauHao,
        Data: listKhauHao,
      },
    });
  }, [listKhauHao]);

  const onChangeThuocTinhTaiSan = (configId) => (e) => {
    const newOptions = datanew.Options.map((item, index) => {
      if (index === configId) {
        return {
          ...item,
          OptionValue: e.target.value,
        };
      }
      return item;
    });
    update({
      ...datanew,
      Options: newOptions,
    });
  };

  const onChangeDataKhauHao = (field) => (event) => {
    update({
      ...datanew,
      KhauHao: {
        ...datanew.KhauHao,
        [field]: event.target.value,
      },
    });
  };

  const onChangeNgayVay = (evt) => {
    update({
      ...datanew,
      KhauHao: {
        ...datanew.KhauHao,
        ThoiGianBatDauKhauHao: evt,
      },
    });
  };

  const generateKhauHao = () => {
    const tien = Number(datanew?.KhauHao?.TienKhauHao || 0);
    const thoiGian = Number(datanew?.KhauHao?.ThoiGianKhauHao || 0);
    const loai = Number(datanew?.KhauHao?.LoaiThoiGianKhauHao || 1);
    const startDate = datanew?.KhauHao?.ThoiGianBatDauKhauHao;

    if (!tien || !thoiGian || !startDate) return;

    const start = new Date(startDate);
    let totalMonths = 0;

    if (loai === 1) {
      // Tháng
      totalMonths = thoiGian;
    } else {
      // Năm -> render tới tháng 12 của năm cuối
      const startMonth = start.getMonth() + 1;
      totalMonths = thoiGian * 12 - startMonth + 1;
    }

    let data = [];

    for (let i = 0; i < totalMonths; i++) {
      let d = new Date(start);
      d.setMonth(start.getMonth() + i);

      data.push({
        thang: d.getMonth() + 1,
        nam: d.getFullYear(),
        SoTien: tien,
      });
    }

    setListKhauHao(data);
  };

  return (
    <>
      <div className="col-md-12 mt-1">
        <div className="row">
          <div className="col-md-12">
            <div className="card-header">
              <a className="card-title lead info collapsed">
                <h3>Thông tin tài sản</h3>
              </a>
            </div>
          </div>

          {datanew.Options &&
            datanew.Options.map((item, index) => (
              <div className="col-md-3" key={"Thuoctinhts1" + index}>
                <TextInputOnRow
                  labelClass="label-control color7-bold"
                  inputClass="form-control input-sm"
                  wrapperClass="form-group"
                  labelText={item.TenThuocTinh}
                  inputProps={{
                    ref: register,
                    name: "datanew[" + index + "].OptionValue",
                    onChange: onChangeThuocTinhTaiSan(index),
                    value: datanew.Options[index].OptionValue,
                  }}
                ></TextInputOnRow>
                <input
                  type="hidden"
                  name={"datanew[" + index + "].OptionName"}
                  value={item.MaThuocTinh}
                  ref={register}
                ></input>
              </div>
            ))}
          <br />
          <div className="col-md-12"></div>
          <div className="col-md-3">
            {/* <TextInputOnRow
              labelClass="label-control color7-bold"
              inputClass="form-control input-sm"
              wrapperClass="form-group"
              labelText="n"
              inputProps={{
                ref: register,
                name: "GiaTriTaiSan",
                onChange: onChangeDataKhauHao("GiaTriTaiSan"),
                value: formatNumber(datanew.KhauHao.GiaTriTaiSan),
              }}
            ></TextInputOnRow> */}
            <NumberInput
              labelClass="col-md-4 label-control"
              inputClass="form-control input-sm"
              inputWrapClass="col-md-8"
              wrapperClass="row"
              labelText="Giá trị tài sản"
              starRed="*"
              placeholder="10,000,000"
              inputProps={{
                name: "GiaTriTaiSan",
                value: datanew.KhauHao.GiaTriTaiSan,
                onChange: onChangeDataKhauHao("GiaTriTaiSan"),
                rules: {
                  required: "Hãy nhập số tiền vay",
                },
                control: control,
                readOnly: false,
              }}
              error={errors.GiaTriTaiSan}
            ></NumberInput>
          </div>
          <div className="col-md-3">
            <label className="label-control color7-bold">Hiện trạng</label>
            <select
              name="TrangThaiTaiSan"
              className="selectBox form-control input-sm"
              value={datanew.KhauHao.TrangThaiTaiSan}
              onChange={onChangeDataKhauHao("TrangThaiTaiSan")}
            >
              <option value="0">Cũ</option>
              <option value="1">Mới</option>
            </select>
          </div>

          <div className="col-md-3">
            <TextInputOnRow
              labelClass="label-control color7-bold"
              inputClass="form-control input-sm"
              wrapperClass="form-group"
              labelText="Tiền khâu hao"
              inputProps={{
                ref: register,
                name: "TienKhauHao",
                onChange: onChangeDataKhauHao("TienKhauHao"),
                value: datanew.KhauHao.TienKhauHao,
              }}
            ></TextInputOnRow>
          </div>
          <div className="col-md-3"></div>
          <div className="col-md-3">
            <TextInputOnRow
              labelClass="label-control color7-bold"
              inputClass="form-control input-sm"
              wrapperClass="form-group"
              labelText="Thời gian khấu hao"
              inputProps={{
                ref: register,
                name: "ThoiGianKhauHao",
                onChange: onChangeDataKhauHao("ThoiGianKhauHao"),
                value: datanew.KhauHao.ThoiGianKhauHao,
              }}
            ></TextInputOnRow>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label className="label-control color7-bold">Loại</label>
              <select
                name="LoaiThoiGianKhauHao"
                className="selectBox form-control input-sm"
                value={datanew.KhauHao.LoaiThoiGianKhauHao}
                onChange={onChangeDataKhauHao("LoaiThoiGianKhauHao")}
                ref={register}
              >
                <option value="1">Tháng</option>
                <option value="2">Năm</option>
              </select>
            </div>
          </div>
          <div className="col-md-3">
            <label className="label-control color7-bold">
              Thời gian bắt đầu tính khấu hao
            </label>
            <DateTimePicker
              value={
                datanew?.KhauHao?.ThoiGianBatDauKhauHao
                  ? new Date(datanew.KhauHao.ThoiGianBatDauKhauHao)
                  : null
              }
              name="ThoiGianBatDauKhauHao"
              onChange={onChangeNgayVay}
            />
          </div>
          <div className="col-md-12 mt-2">
            <div className="row">
              {listKhauHao.map((item, index) => (
                <div className="col-md-2" key={index}>
                  <TextInputOnRow
                    labelClass="label-control color7-bold"
                    inputClass="form-control input-sm"
                    wrapperClass="form-group"
                    labelText={`${item.thang}/${item.nam}`}
                    inputProps={{
                      value: item.SoTien,
                      onChange: (e) => {
                        const newData = [...listKhauHao];
                        newData[index].SoTien = e.target.value;
                        setListKhauHao(newData);
                      },
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-12 mt-1">
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <UploadMultiFile
                Files={AnhTaiSan}
                onChange={updateAnhTaiSan}
                Code={nameCode}
              ></UploadMultiFile>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
